import React from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    ButtonGroup,
    chakra,
    FormControl,
    GridItem,
    SimpleGrid,
    Stack,
    Textarea,
    useColorModeValue,
    useBreakpointValue,
} from '@chakra-ui/react';
import {FaDiscord, FaSlack} from 'react-icons/fa';
import {getEmoji as slackGetEmoji} from './Slack';

export const Input = ({message, onMessageChange, chatClient, onClientClick, ...props}) => {
    const emojiSize = useBreakpointValue({ base: 14, sm: 16, md: 18, lg: 20, xl: 22 });
    return (
        <chakra.form
            shadow="base"
            rounded={[null, 'md']}
            overflow={{sm: 'hidden'}}
        >
            <Stack
                px={4}
                py={5}
                bg={useColorModeValue('white', 'gray.700')}
                spacing={6}
                p={{sm: 6}}
            >
                <SimpleGrid columns={6} spacing={6}>
                    <FormControl id="input" as={GridItem} colSpan={6}>
                        <Textarea placeholder="Enter your message here to have it converted to emojis"
                                  value={message} mt={1} rows={3} shadow="sm" focusBorderColor="brand.400"
                                  fontSize={{sm: 'sm'}} onChange={onMessageChange}/>
                    </FormControl>

                    <FormControl as={GridItem} colSpan={[6, 3]}>
                        <ButtonGroup isAttached={true} spacing={0}>
                            <Button id='slack' leftIcon={<FaSlack />} isActive={String(chatClient).startsWith('slack')} _active={{bg: 'purple', color: 'white'}} onClick={onClientClick}>Slack</Button>
                            <Button id='discord' leftIcon={<FaDiscord />} isActive={chatClient === 'discord'} _active={{bg: 'purple', color: 'white'}} onClick={onClientClick}>Discord</Button>
                        </ButtonGroup>
                        {String(chatClient).startsWith('slack') && (
                            <Stack mt={4} spacing={2} direction='row' flexWrap='wrap'>
                                <Button id='slack-white' onClick={onClientClick} isActive={chatClient === 'slack-white' || chatClient === 'slack'} _active={{bg: 'purple', color: 'white'}} whiteSpace='normal' display='flex' flexWrap='wrap' px={3} py={2}>
                                    {slackGetEmoji('white', 'white', emojiSize)}
                                </Button>
                                <Button id='slack-yellow' onClick={onClientClick} isActive={chatClient === 'slack-yellow'} _active={{bg: 'purple', color: 'white'}} whiteSpace='normal' display='flex' flexWrap='wrap' px={3} py={2}>
                                    {slackGetEmoji('yellow', 'yellow', emojiSize)}
                                </Button>
                                <Button id='slack-annoying' onClick={onClientClick} isActive={chatClient === 'slack-annoying'} _active={{bg: 'purple', color: 'white'}} whiteSpace='normal' display='flex' flexWrap='wrap' px={3} py={2}>
                                    {slackGetEmoji('annoying', 'annoying', emojiSize)}
                                </Button>
                            </Stack>
                        )}
                    </FormControl>
                </SimpleGrid>
            </Stack>
        </chakra.form>

    );
};

Input.propTypes = {
    message: PropTypes.string.isRequired,
    onMessageChange: PropTypes.func,
    onClientClick: PropTypes.func,
};

Input.defaultProps = {
    message: '',
    onMessageChange: undefined,
    onClientClick: undefined,
};